/**
 * Cleo ERP SaaS — Page de vérification email
 * Appelée depuis le lien dans l'email de vérification.
 * GET /api/tenants/verify-email/<token>/
 */
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Typography, Spin, Alert, Button } from 'antd';
import {
  CheckCircleFilled, CloseCircleFilled, LoadingOutlined,
} from '@ant-design/icons';
import api from '../../api/axios';

const { Title, Paragraph } = Typography;

function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');
  const [slug, setSlug] = useState('');

  useEffect(() => {
    api.get(`/api/tenants/verify-email/${token}/`)
      .then(({ data }) => {
        setStatus('success');
        setMessage(data.detail);
        setSlug(data.slug || '');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(
          err.response?.data?.detail || 'Ce lien de vérification est invalide ou a expiré.'
        );
      });
  }, [token]);

  if (status === 'loading') {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 36, color: '#10B981' }} />} />
        <Paragraph style={{ color: '#64748B', marginTop: 16 }}>
          Vérification en cours...
        </Paragraph>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{ textAlign: 'center' }}>
        <CloseCircleFilled style={{ fontSize: 48, color: '#EF4444', marginBottom: 16 }} />
        <Title level={3} style={{ color: '#0F172A', marginBottom: 8 }}>
          Vérification échouée
        </Title>
        <Paragraph style={{ color: '#64748B', marginBottom: 24 }}>
          {message}
        </Paragraph>
        <Link to="/register">
          <Button type="primary" size="large">
            Nouvelle inscription
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <CheckCircleFilled style={{ fontSize: 48, color: '#10B981', marginBottom: 16 }} />
      <Title level={3} style={{ color: '#0F172A', marginBottom: 8 }}>
        Email vérifié
      </Title>
      <Paragraph style={{ color: '#64748B', marginBottom: 24 }}>
        {message}
      </Paragraph>
      {slug && (
        <div style={{
          background: '#ECFDF5',
          borderRadius: 8,
          padding: '12px 16px',
          marginBottom: 24,
        }}>
          <Paragraph style={{ color: '#064E3B', fontSize: 13, margin: 0 }}>
            Votre instance : <strong style={{ color: '#10B981' }}>{slug}.cleoerp.com</strong>
          </Paragraph>
        </div>
      )}
      <Link to="/login">
        <Button type="primary" size="large" block>
          Se connecter
        </Button>
      </Link>
    </div>
  );
}

export default VerifyEmailPage;
